module.exports = __webpack_public_path__ + "img/Construct.695e0e84.svg";